import React from 'react';

import { SimpleIcon } from './icon-utils';

export function MoreVerticalIcon() {
  return (
    <SimpleIcon height="24" viewBoxDimensions="0 0 24 24" width="24">
      <path
        clipRule="evenodd"
        d="M12.5 9C11.6716 9 11 8.32843 11 7.5C11 6.67157 11.6716 6 12.5 6C13.3284 6 14 6.67157 14 7.5C14 8.32843 13.3284 9 12.5 9ZM12.5 19C11.6716 19 11 18.3284 11 17.5C11 16.6716 11.6716 16 12.5 16C13.3284 16 14 16.6716 14 17.5C14 18.3284 13.3284 19 12.5 19ZM11 12.5C11 13.3284 11.6716 14 12.5 14C13.3284 14 14 13.3284 14 12.5C14 11.6716 13.3284 11 12.5 11C11.6716 11 11 11.6716 11 12.5Z"
        fill="#324A52"
        fillRule="evenodd"
      />
    </SimpleIcon>
  );
}
